module.exports = __webpack_public_path__ + "b3inventory.b1853dc7b6d45058f5a5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/yardobject/font/b3inventory.woff2?14714644
// module id = 898
// module chunks = 3